import { render, staticRenderFns } from "./carOwner.vue?vue&type=template&id=372af0ac&scoped=true"
import script from "./carOwner.vue?vue&type=script&lang=js"
export * from "./carOwner.vue?vue&type=script&lang=js"
import style0 from "./carOwner.vue?vue&type=style&index=0&id=372af0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372af0ac",
  null
  
)

export default component.exports